/* global globals */
/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Slider from 'react-slick';
import MembersBlock from './MembersBlock';
import { ImageSvg } from '../image';

export default class MembersGrid extends Component {
  render() {
    let { topNr, members, customImages } = this.props;
    const {
      showDistance,
      extended,
      type,
      subtype,
      page,
      slider,
      slideTotal,
      sliderAutoplay,
      menuType,
    } = this.props;

    // Vērtētākie foto: Nomaina bildi, pieliek vairākas reizes lietotāja
    if (customImages && _.isString(customImages) && customImages !== 'null') {
      try {
        customImages = JSON.parse(customImages);
        const items = [];
        // Tikai šajā gadījumā nepieciešams,lai key ir id, tapēc te to members pārveido.
        // Varētu arī iekš' customImages iet cauri members un salīdzināt id.
        // Bet sanāk, ka tad to forEach izpildītu katrai bildei, šādi tas jāizpilda tikai vienreiz.
        const membersArray = Object.values(members);
        members = {};
        membersArray.forEach((member) => {
          members[member._id] = member;
        });
        customImages.forEach((item) => {
          if (members[item.member_id]) {
            // Šāds variants, lai pie vērtētākajām bildēm nerāda vienādas bildes..
            items.push({
              _id: item.member_id,
              about_me: members[item.member_id].about_me,
              admin: members[item.member_id].admin,
              age: members[item.member_id].age,
              answer_score: members[item.member_id].answer_score,
              blocked: members[item.member_id].blocked,
              can_access: members[item.member_id].can_access,
              custom_link: `${_.get(globals, 'webroot', '')}member/${item.member_id}`,
              deleted: members[item.member_id].deleted,
              favorite: members[item.member_id].favorite,
              has_paid: members[item.member_id].has_paid,
              image: item.filename,
              image_count: members[item.member_id].image_count,
              km_from_me: members[item.member_id].km_from_me,
              location: members[item.member_id].location,
              name: members[item.member_id].name,
              sex: members[item.member_id].sex,
              status: members[item.member_id].status,
              videochat: members[item.member_id].videochat,
              was_messaged_by_me: members[item.member_id].was_messaged_by_me,
              was_visited_by_me: members[item.member_id].was_visited_by_me,
              verified: members[item.member_id].verified,
            });
          }
        });

        members = items;
      } catch (e) {
        // const { customImages } = this.props;
      }
    }

    const getElement = () => {
      if (slider === false) {
        return (
          <MembersBlock
            members={members}
            extended={extended}
            type={type}
            subtype={subtype}
            page={page}
            topNr={topNr}
            showDistance={showDistance}
            menuType={menuType}
          />
        );
      }
      let membersInSlide;
      const slides = [];

      let slide = 0;

      members = Object.values(members);
      // eslint-disable-next-line react/prop-types
      if (members.length < 1) {
        return <div />;
      }

      // eslint-disable-next-line react/prop-types
      while (members.length > 0) {
        if (topNr != null && slide > 0) {
          topNr += (slide * slideTotal);
        }

        // eslint-disable-next-line react/prop-types
        membersInSlide = members.splice(0, slideTotal);
        const memberSlide = [
          <div>
            <MembersBlock
              members={membersInSlide}
              extended={extended}
              type={type}
              subtype={subtype}
              page={page}
              topNr={topNr}
              showDistance={showDistance}
              menuType={menuType}
            />
          </div>,
        ];

        slides.push(memberSlide);

        slide += 1;
      }

      /* eslint-disable react/jsx-props-no-spreading */
      const PrevArrow = ({ currentSlide, slideCount, ...props }) => (
        <button
          {...props}
          type="button"
          className="slick-arrow slick-prev"
          style={{ display: 'block' }}
        >
          <ImageSvg svg="icon-arrowleftlarge" iconClass="icon icon--full" />
        </button>
      );

      const NextArrow = ({ currentSlide, slideCount, ...props }) => (
        <button
          {...props}
          type="button"
          className="slick-arrow slick-next"
          style={{ display: 'block' }}
        >
          <ImageSvg svg="icon-arrowrightlarge" iconClass="icon icon--full" />
        </button>
      );
      /* eslint-enable react/jsx-props-no-spreading */

      return (
        <Slider
          dots
          autoplay={sliderAutoplay}
          prevArrow={<PrevArrow />}
          nextArrow={<NextArrow />}
          initialSlide={0}
          ref={(el) => { this.slickRef = el; }}
        >
          {slides}
        </Slider>
      );
    };

    return (
      getElement()
    );
  }
}

MembersGrid.propTypes = {
  topNr: PropTypes.number,
  slideTotal: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  subtype: PropTypes.string,
  extended: PropTypes.bool.isRequired,
  slider: PropTypes.bool.isRequired,
  sliderAutoplay: PropTypes.bool,
  customImages: PropTypes.string,
  showDistance: PropTypes.bool.isRequired,
  members: PropTypes.shape({}).isRequired,
  menuType: PropTypes.string,
};

MembersGrid.defaultProps = {
  topNr: null,
  customImages: null,
  sliderAutoplay: false,
  subtype: '',
  menuType: 'user',
};
